export default {
  retail: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Comercio y hostelería',
    hero: {
      eyebrow: 'Comercio y hostelería',
      title: 'Más seguridad en tiendas y hostelería',
      lead: 'Entrada, caja, almacén y acceso a cocina: protegemos su negocio contra robos y vandalismo sin molestar a sus clientes.',
    },
    points: {
      title: 'Puntos de vigilancia para comercio y hostelería',
      lead: 'Cada tienda y negocio hostelero tiene sus propias zonas de riesgo. Colocamos las cámaras justo donde marcan la diferencia.',
      items: {
        '0': { title: 'Entrada y escaparate', desc: 'El primer punto de vigilancia: las cámaras de la entrada documentan quién entra y sale, y disuaden desde el primer momento.' },
        '1': { title: 'Zona de caja', desc: 'La caja y el área de pago son el punto más sensible del comercio. Cámaras discretas aseguran la zona sin inquietar a los clientes.' },
        '2': { title: 'Sala de ventas', desc: 'Visión de toda la superficie: las cámaras gran angular detectan movimientos sospechosos en estanterías y pasillos.' },
        '3': { title: 'Almacén y recepción', desc: 'Recepción de mercancía, almacén y accesos de personal: aquí aparecen huecos cuando entra o sale mercancía. Los cerramos.' },
        '4': { title: 'Barra y acceso a cocina', desc: 'En hostelería, la barra y el acceso a cocina son zonas críticas. Cámaras robustas resisten humedad y calor.' },
        '5': { title: 'Terraza exterior', desc: 'Terraza y mesas exteriores invitan a los ladrones, sobre todo de noche. Cámaras resistentes vigilan.' },
      },
    },
    protection: {
      eyebrow: 'Protección antirrobo',
      title: 'Menos pérdidas de inventario, más seguridad',
      lead: 'Los hurtos y las diferencias de inventario cuestan mucho dinero cada año. Cámaras bien ubicadas reducen pérdidas y aportan imágenes útiles.',
      items: {
        '0': { title: 'Vigilancia de caja', desc: 'Imágenes nítidas de caja y zona de pago, para documentación completa en disputas y manipulaciones.' },
        '1': { title: 'Escaparates y accesos', desc: 'Disuasión y aclaración ante vandalismo o robo, del escaparate a la puerta trasera.' },
        '2': { title: 'Registros de eventos', desc: 'Movimiento, cruce de línea o puertas activan grabación y avisos push, justo cuando importa.' },
      },
    },
    gastro: {
      eyebrow: 'Hostelería',
      title: 'Tecnología robusta para barra, cocina y terraza',
      lead: 'Vapor, grasa y humedad exigen mucho a la tecnología. Elegimos cámaras que funcionan de forma fiable en el día a día hostelero y que los clientes no notan.',
      list: {
        '0': 'Vigilar el acceso a cocina: solo personal autorizado',
        '1': 'Asegurar barra y caja sin molestar a los clientes',
        '2': 'Terraza exterior a la vista en las horas de la tarde',
        '3': 'Documentar proveedores y entregas sin huecos',
        '4': 'Colocar señalización para clientes y personal',
      },
      note: 'Nota: la legalidad de la videovigilancia depende del caso concreto. Le asesoramos, sin sustituir el asesoramiento jurídico.',
    },
    cta: {
      title: 'Su negocio merece un marco seguro',
      lead: 'Le mostramos sin compromiso dónde le compensa la videovigilancia y dónde no es necesaria.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Descubrir SSG Care',
    },
  },
};